import { colors, IconButton, Tooltip } from "@mui/material";
import NotificationsNoneRounded from "@mui/icons-material/NotificationsNoneRounded";

export default function Notifications() {
  return (
    <Tooltip title="Notification alerts - No alerts">
      <IconButton>
        <NotificationsNoneRounded />
      </IconButton>
    </Tooltip>
  );
}
